export default {
  'announcementmanagement.text': 'text',
};
